import { useQuery } from '@tanstack/react-query';
import { getEquiposPorIdTemporadaYLetras, getEquipoByIdTemporadaAndIdEquipo } from '../../services/equiposService';

/**
 * Hook para obtener equipos por temporada y letras (búsqueda)
 * @param {number} idTemporada - ID de la temporada
 * @param {string} letras - Letras para filtrar equipos
 * @param {object} options - Opciones de React Query
 */
export const useEquipos = (idTemporada, letras = '', options = {}) => {
  return useQuery({
    queryKey: ['equipos', idTemporada, letras],
    queryFn: () => getEquiposPorIdTemporadaYLetras(idTemporada, letras, null),
    enabled: !!idTemporada,
    staleTime: 15 * 60 * 1000, // 15 minutos
    ...options,
  });
};

/**
 * Hook para obtener un equipo por ID de temporada e ID de equipo
 * @param {number} idTemporada - ID de la temporada
 * @param {number} idEquipo - ID del equipo
 * @param {object} options - Opciones de React Query
 */
export const useEquipoById = (idTemporada, idEquipo, options = {}) => {
  return useQuery({
    queryKey: ['equipo', idTemporada, idEquipo],
    queryFn: () => getEquipoByIdTemporadaAndIdEquipo(idTemporada, idEquipo, null),
    enabled: !!(idTemporada && idEquipo),
    staleTime: 15 * 60 * 1000, // 15 minutos
    ...options,
  });
};

export { useEquipos as default };
